<pbc-filter-preset
  [filter]="gutachtens.preset$ | async"
  [filters]="gutachtens.presets$ | async"
  [name]="gutachtens.search$ | async"
  (select)="gutachtens.setFilter($event)"
  (save)="gutachtens.writeFilter($event)"
  (delete)="gutachtens.deleteFilter($event)"
></pbc-filter-preset>
